import React from 'react';
import Styles, { centerAbs } from './BecomeAnOyoStyles';
import LandingImages from '../LandingPageNew/LandingImages';
import { S3HOST } from '../../ApiConstants';
import * as GlobalActions from '../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import view, {
  oyoFormView,
  oyoFormHeights,
  validation,
  propertyType,
  carouselMode
} from '../../Enums';
import CheckEarningsWidget from './BecomeAnOyoSubComponents/CheckEarningsWidget';
import GenerateOtpWidget from './BecomeAnOyoSubComponents/GenerateOtpWidget';
import HomeStepTwoWidget from './BecomeAnOyoSubComponents/HomeStepTwoWidget';
import SignUpScreenWidget from './BecomeAnOyoSubComponents/SignUpScreenWidget';
import { validateUserPhoneNumber } from '../../utils/tempInputUtils';
import allCountriesData from '../../utils/country-code-mapping';
import BottomNavigations from './BecomeAnOyoSubComponents/BottomNavigations';
import LoginWidget from './BecomeAnOyoSubComponents/LoginWidget';
import countryNamesByISO from '../../utils/regionCodeMappings';
import { CircularProgress } from '@material-ui/core';
import HotelStepTwoWidget from './BecomeAnOyoSubComponents/HotelStepTwoWidget';
import Component from '../../ui-components/Component';
import { isEmptyString, path } from '../../utils';
import LoginWithOtpStepOneWidget from './BecomeAnOyoSubComponents/LoginWithOtpStepOneWidget';
import LoginWithOtpStepTwoWidget from './BecomeAnOyoSubComponents/LoginWithOtpStepTwoWidget';
import { earningPotentialEnabled, hmsSelfOnboardingEnabled } from '../../config/countryConfig';
import { EVENT_ACTIONS, EVENT_CATEGORIES, logEvent, EVENT_TYPE, EVENT_NAME } from '../../services/Analytics';
import { OYO_LIFE_BASE_URL } from '../../ApiConstants';

class BecomeAnOyoScreen extends Component {
  
  translation_key = 'landing_translations';
  styles = Styles;
  images = LandingImages;
  
  gi = key => {
    let ret = !isEmptyString(path(this.images, `${key}.${this.getViewMode()}`))
        ? `${S3HOST}/${this.props.translationsData.universal_translations[this.images[key][this.getViewMode()]]}` : null;
    
    if(ret == null)return !isEmptyString(path(this.images, `${key}.${ view.MOBILE}`))
        ? `${S3HOST}/${this.props.translationsData.universal_translations[this.images[key][view.MOBILE]]}` : null;
    
    return ret
  };
  
  gs = key => path(this.styles, `${key}.${this.getViewMode()}`, path(this.styles,`${key}.${view.MOBILE}`,{}));
  
  constructor(props) {
    super(props);
    this.onLocationTextUpdate = this.onLocationTextUpdate.bind(this);
    this.changeFormScreen = this.changeFormScreen.bind(this);
    this.validateOneField = this.validateOneField.bind(this);
    this.setSignUpFunction = this.setSignUpFunction.bind(this);
    this.setLoginFunction = this.setLoginFunction.bind(this);
    this.regenerateOtp = this.regenerateOtp.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.globalData.otpData.isFetching &&
      !this.props.globalData.otpData.isFetching
    ) {
      let otpData = this.props.globalData.otpData;
      if (
          path(otpData,"data.status",false) &&
        this.state.oyoFormMode == oyoFormView.otpScreen
      ) {
        this.changeFormScreen(oyoFormView.signUpScreen);
      }
      if (
          path(otpData,"data.status",false) &&
          this.state.oyoFormMode == oyoFormView.loginWithOtpStepOne
      ) {
        this.changeFormScreen(oyoFormView.loginWithOtpStepTwo);
      }
    }

    if (
      prevProps.globalData.propertyData.isFetching &&
      !this.props.globalData.propertyData.isFetching &&
      !this.props.globalData.propertyData.isFetching
    ) {
      // either home step 2 or hotel step 2 with hotel name validated
      if (
        this.state.oyoFormMode == oyoFormView.homeStepTwo ||
        (this.state.oyoFormMode == oyoFormView.hotelStepTwo && this.props.globalData.formData.hotel_name.length > 0)
      ) {
        this.props.globalActions.emptyFormData();
        this.setState({
          resultant_ph_no:this.props.globalData.formData.dial_code+' '
        });
        if(!earningPotentialEnabled()){
          // if earning potential is disabled, we go to home basic form
          this.setState({ oyoFormMode: oyoFormView.otpScreen });
        }else{
          this.changeFormScreen(oyoFormView.checkEarnings);
        }
        this.props.showMessageModal();
      } else if (this.state.oyoFormMode == oyoFormView.homeBasic) {
        this.changeFormScreen(oyoFormView.homeStepTwo);
      }
    }

    if (
      prevProps.globalData.signUpData.isFetching &&
      !this.props.globalData.signUpData.isFetching
    ) {
      let signUpData = this.props.globalData.signUpData;
      
      if (!signUpData.errorMessage) {
        this.props.globalActions.putGenOtpPropertyfetch(this.getBasicDataToStore(true));
        this.changeFormScreen(oyoFormView.loginScreen);
        this.setState({successful_sign_up : true});
      }
      else this.setState({successful_sign_up : false});
    }

    if (
      prevProps.globalData.locationData.isFetching &&
      !this.props.globalData.locationData.isFetching &&
      this.props.globalData.location
    ) {
      if (
        this.props.globalData.locationData.location.responseObject &&
        this.props.globalData.locationData.location.responseObject.length
      ) {
        this.setState({
          showDropdown: true,
          dropDownOptions: this.props.globalData.locationData.location
            .responseObject
        });
      } else {
        this.setState({
          showDropdown: true,
          dropDownOptions: [{
            type : 'error',
            displayName: 'Can\'t find relevant results, try retyping'
          }]
        });
      }
    }
  }

  state = {
    oyoFormMode: oyoFormView.checkEarnings,
    showDropdown: false,
    dropDownOptions: [],
    selectedLocation: null,
    showDropdownMobile: false,
    flagPos: 1360,
    resultant_ph_no: null,
    name_border_validated: true,
    ph_no_border_validated: true,
    location_border_validated: true,
    hotel_name_border_validated: true,
    email_border_validated: true,
    hotel_address_border_validated: true,
    debounceTimer: null,
    location: '',
    signUpFunction: null,
    loginFunction: null,
    struct_type_validated: true,
    location_error : '',
    successful_sign_up : false,
    eventCategory: EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOTEL
  };

  // passing a reference to child in order to capture function to be triggered to sign up
  setSignUpFunction = func => {
    this.setState({ signUpFunction: func });
  };

  // passing a reference to child in order to capture function to be triggered to sign up
  setLoginFunction = func => {
    this.setState({ loginFunction: func });
  };

  handleGreenButtonOnClick = e => {
    let nameValidated, phoneValidated, locationValidated;
    let validateNameHotel, validateEmail;
    let validateStructType, validateAddressHome;
    switch (this.state.oyoFormMode) {
      case oyoFormView.checkEarnings:
        if (this.validateOneField(validation.LOCATION)) {
          const locationData = {
            city: path(this.state.selectedLocation, 'city.name',''),
            state:path(this.state.selectedLocation,'state.name',''),
            country:path(this.state.selectedLocation,'country.name',''),
            roomCount:path(this.props.globalData,'number_of_rooms',''),
            estimatedRevenue:path(this.props.globalData,'estimated_revenue','')
          };
          logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM, EVENT_ACTIONS.STEP_1_GET_ASSOCIATED_CLICKED, JSON.stringify(locationData));
          hmsSelfOnboardingEnabled() ? this.props.redirectToHms():this.changeFormScreen(oyoFormView.otpScreen);
        }
        break;
  
      case oyoFormView.lifeBasic:
        this.lifeBasicSubmission();
        break;

      case oyoFormView.homeBasic:
        nameValidated = this.validateOneField(validation.FULL_NAME);
        phoneValidated = this.validateOneField(validation.PHONE_NUMBER);
        locationValidated = this.validateOneField(validation.LOCATION);

        if (nameValidated && phoneValidated && locationValidated) {
          this.props.globalActions.putPropertyfetch(this.getBasicDataToStore());
          const ctaData = {
            name: path(this.props.globalData.formData,'full_name',''),
            phone:  path(this.props.globalData.formData,'mobile_number',''),
            city: path(this.state.selectedLocation, 'city.name',''),
            state:path(this.state.selectedLocation,'state.name',''),
            country:path(this.state.selectedLocation,'country.name',''),
          };
          logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOME, EVENT_ACTIONS.STEP_1_REQUEST_A_CALL_CLICKED, JSON.stringify(ctaData), '', EVENT_NAME.LEAD, EVENT_TYPE.TRACK);
        }

        break;

      case oyoFormView.hotelBasic:
        this.hotelBasicSubmission();
        break;

      case oyoFormView.otpScreen:
        [nameValidated,phoneValidated,locationValidated] = this.validateGenOtpFields();
        
        if (nameValidated && phoneValidated && locationValidated) {
          logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM,EVENT_ACTIONS.GENERATE_OTP_CLICKED,'','', EVENT_NAME.LEAD, EVENT_TYPE.TRACK);
          this.props.globalActions.putGenOtpPropertyfetch(this.getBasicDataToStore(true));
          let iso_code = this.props.globalData.locale;
          if (iso_code) iso_code = iso_code.toUpperCase();
          this.props.globalActions.postOtp(
            this.props.globalData.formData.mobile_number,
            this.props.globalData.formData.dial_code,
            iso_code
          );
        }
        break;
      case oyoFormView.homeStepTwo:
        validateAddressHome = this.validateOneField(validation.HOME_ADDRESS);
        validateStructType = this.validateOneField(
          validation.HOME_STRUCTURE_TYPE
        );

        if (validateAddressHome && validateStructType) {
          let homeData = {
            ...this.getBasicDataToStore(),
            street_address: this.props.globalData.formData.hotel_address,
            property_component_type: 'Home',
            home__structure_type: this.props.globalData.formData
              .structure_type_home,
            ownership: this.props.globalData.formData.are_you_a_owner,
            home__occupancy_status: this.props.globalData.formData
              .occupancy_status
          };

          this.props.globalActions.putPropertyfetch(homeData);
          const ctaData = {
            address: path(this.props.globalData.formData, 'hotel_address', ''),
            structureType: path(this.props.globalData.formData, 'structure_type_home', ''),
            occupancyStatus: path(this.props.globalData.formData, 'occupancy_status', ''),
            ownership: path(this.props.globalData.formData, 'are_you_a_owner')
          };
          logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOME, EVENT_ACTIONS.STEP_2_SUBMIT_AND_FINISH_CLICKED, JSON.stringify(ctaData), '', EVENT_NAME.LEAD, EVENT_TYPE.TRACK);
        }

        break;

      case oyoFormView.signUpScreen:
        if (this.state.signUpFunction) this.state.signUpFunction();
        break;

      case oyoFormView.loginScreen:
        if (this.state.loginFunction) this.state.loginFunction();
        break;
      case oyoFormView.hotelStepTwo:
        validateNameHotel = this.validateOneField(
          validation.HOTEL_PROPERTY_NAME
        );
        validateEmail = this.validateOneField(validation.HOTEL_EMAIL);
        if (validateNameHotel && validateEmail) {
          let hotelFinalData = {
            ...this.props.globalData.propertyData.data,
            ...this.getBasicDataToStore(),
            street_address: this.props.globalData.formData.hotel_address,
            hotel_total_rooms: this.props.globalData.number_of_rooms,
            name: this.props.globalData.formData.hotel_name,
            owner_email: this.props.globalData.formData.email_address
          };
          this.props.globalActions.putPropertyfetch(hotelFinalData);
          const ctaData = {
            address:path(this.props.globalData.formData,'hotel_address',''),
            hotelName:path(this.props.globalData.formData,'hotel_name',''),
            email:path(this.props.globalData.formData,'email_address','')
          };
          logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOTEL, EVENT_ACTIONS.STEP_3_SUBMIT_AND_FINISH_CLICKED, JSON.stringify(ctaData), '', EVENT_NAME.LEAD, EVENT_TYPE.TRACK);
        }
        break;
      case oyoFormView.loginWithOtpStepOne:
        phoneValidated = this.validateOneField(validation.PHONE_NUMBER);
        if (phoneValidated) {
          let iso_code = this.props.globalData.locale;
          if (iso_code) iso_code = iso_code.toUpperCase();
          this.props.globalActions.postOtpLogin(
              this.props.globalData.formData.mobile_number,
              this.props.globalData.formData.dial_code,
              iso_code
          );
        }
        break;
      case oyoFormView.loginWithOtpStepTwo:
        if (this.state.loginFunction) this.state.loginFunction();
        break;
      case oyoFormView.hmsSelfOnboardingHome:
        if (this.validateOneField(validation.LOCATION)) {
          const ctaData = {
            city: path(this.state.selectedLocation, 'city.name', ''),
            state: path(this.state.selectedLocation, 'state.name', ''),
            country: path(this.state.selectedLocation, 'country.name', '')
          };
          logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOME, EVENT_ACTIONS.STEP_1_GET_ASSOCIATED_CLICKED, JSON.stringify(ctaData), '', EVENT_NAME.LEAD, EVENT_TYPE.TRACK);
          this.props.redirectToHms();
        }
        break;
    }
  };

  hotelBasicSubmission = () => {
    let nameValidated, phoneValidated, locationValidated;
    nameValidated = this.validateOneField(validation.FULL_NAME);
    phoneValidated = this.validateOneField(validation.PHONE_NUMBER);
    locationValidated = this.validateOneField(validation.LOCATION);

    if (nameValidated && phoneValidated && locationValidated) {
      this.props.globalActions.putPropertyfetch(this.getBasicDataToStore());
    }
  };
  
  lifeBasicSubmission = () => {
    if (this.validateOneField(validation.LOCATION)) {
      const { name, id } = this.state.selectedLocation.city;
      window.open(OYO_LIFE_BASE_URL + '?location=' + name + '&city_id=' + id + '&occupancy=' + this.props.globalData.number_of_rooms);
    }
  };

  changeFormScreen = viewType => {
    
    this.props.globalActions.errorSignUp('');
    this.props.globalActions.errorOtp('');
    this.props.globalActions.errorLogin('');
    
    this.setState({
      name_border_validated: true,
      ph_no_border_validated: true,
      location_border_validated: true,
      hotel_name_border_validated: true,
      email_border_validated: true,
      hotel_address_border_validated: true,
      struct_type_validated:true
    });
    
    
    switch (viewType) {
      case oyoFormView.signUpScreen:
        this.props.globalActions.carouselModeUpdate(carouselMode.SIGN_UP);
        break;

      case oyoFormView.checkEarnings:
        this.props.globalActions.updatePropertyType(propertyType.HOTEL);
        this.setState({ eventCategory: EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOTEL });
        if(!earningPotentialEnabled()){
          // if earning potential is disabled, we go to home basic form
          this.setState({ oyoFormMode: oyoFormView.otpScreen });
          return
        }
        break;

      case oyoFormView.homeBasic:
      case oyoFormView.hmsSelfOnboardingHome:
        this.props.globalActions.updatePropertyType(propertyType.HOME);
        this.setState({ eventCategory: EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOME });
        break;
  
      case oyoFormView.lifeBasic:
        this.props.globalActions.updatePropertyType(propertyType.LIFE);
        break;

      case oyoFormView.loginWithOtpStepOne:
        
        break;
      case oyoFormView.loginWithOtpStepTwo:
        break;
      case oyoFormView.otpScreen:
        break;
      case oyoFormView.loginScreen:
        break;

      default:
        this.props.globalActions.carouselModeUpdate(carouselMode.HOTEL);
    }

    this.setState({ oyoFormMode: viewType });
  };

  setBottomExtra = height => {
    this.setState({ bottomExtra: height });
  };

  regenerateOtp = () => {
    let iso_code = this.props.globalData.locale;
    if(this.state.oyoFormMode === oyoFormView.otpScreen)
      this.props.globalActions.postOtp(
        this.props.globalData.formData.mobile_number,
        this.props.globalData.formData.dial_code,
        iso_code
      );
    else  this.props.globalActions.postOtpLogin(
          this.props.globalData.formData.mobile_number,
          this.props.globalData.formData.dial_code,
          iso_code
      );
  };

  getBasicDataToStore = (genOtp=false) => {
    let typeOfProperty = 'Hotel';
    if (this.props.globalData.type_of_property === propertyType.HOME) {
      typeOfProperty = 'Home';
    }

    let toSend = {
      source: 'OAM',
      sub_source_code: this.props.utm_data,
      hotel_total_rooms: null,
      owner_name: this.props.globalData.formData.full_name,
      property_component_type: typeOfProperty,
      owner_primary_mobile_number: this.props.globalData.formData.mobile_number,
      metadata: {
        freetext: this.state.location,
        medium: 'OAM WEB',
        landingCountry:
          countryNamesByISO[this.props.globalData.locale] ||
          this.props.globalData.locale
      }
    };
    if (this.state.selectedLocation) {
      let selected = this.state.selectedLocation;
      if (selected.city) toSend['city'] = selected.city.name;
      if (selected.country) toSend['country'] = selected.country.name;
    }
    let user_profile_id = path(this.props.globalData,'signUpData.data.id');
    if(genOtp && user_profile_id){
      toSend.metadata.user_profile_id = user_profile_id;
    }
    
    toSend = {
      ...(genOtp?this.props.globalData.propertyGenOtpData.data:this.props.globalData.propertyData.data),
      ...toSend
    };
    

    return toSend;
  };

  componentDidMount() {
    this.props.giveAbilityToChangeOyoForm(this.changeFormScreen);
    this.props.globalActions.updatePropertyType(propertyType.HOTEL);
    
    if(!earningPotentialEnabled()){
      this.changeFormScreen(oyoFormView.otpScreen)
    }

    let mobile_number = this.props.globalData.formData.mobile_number;
    if (
      !validateUserPhoneNumber(this.props.globalData.formData.mobile_number)
    ) {
      mobile_number = '';
      this.props.globalActions.dataUpdate('mobile_number', '');
    }

    this.flagAndDialCode(
      this.props.globalData.locale.toUpperCase(),
      mobile_number
    );
  }

  onLocationTextUpdate = e => {
    let query = e.target.value;
    this.setState({ location: query , selectedLocation : null , location_error : ''});
    this.props.globalActions.updateLocation(query);
    if (this.state.debounceTimer) clearTimeout(this.state.debounceTimer);
    if (query && query.length > 2) {
      this.setState({
        debounceTimer: setTimeout(() => this.getLocationSuggestions(query), 200)
      });
    } else {
      this.setState({ showDropdown: false });
    }
  };

  getLocationSuggestions = query => {
    let country_code = this.props.globalData.locale.toUpperCase();
    if (country_code === 'UK') country_code = 'GB';
    const countryIds = this.props.globalData.type_of_property === propertyType.LIFE ? [allCountriesData[country_code][3]] : [];
    this.props.globalActions.fetchLocationSearch(query, country_code, countryIds);
  };

  onClickDropdown = locationObject => {
    this.setState({ location_border_validated: true });
    this.props.globalActions.updateLocation(locationObject.displayName);
    if (locationObject.city)
      this.props.globalActions.dataUpdate('city', locationObject.city.name);
    if (locationObject.country)
      this.props.globalActions.dataUpdate(
        'country',
        locationObject.country.name
      );
    this.props.globalActions.updateLocationObject(locationObject);
    const locationData = {
      city: path(locationObject, 'city.name',''),
      state:path(locationObject,'state.name',''),
      country:path(locationObject,'country.name','')
    };
    logEvent(this.state.eventCategory, EVENT_ACTIONS.LOCATION_ENTERED, JSON.stringify(locationData));
    this.setState({
      showDropdown: false,
      dropDownOptions: [],
      selectedLocation: locationObject,
      location_error: ''
    });
  };

  onChangeMobileInput = e => {
    let val = e.target.value;
    let normal_border = 'solid 1px rgba(0, 0, 0, 0.08)';
    let dial_code_length = this.props.globalData.formData.dial_code.length;
    if (val.length == 0) {
      this.setState({
        resultant_ph_no: this.props.globalData.formData.dial_code + ' '
      });
    }
    if (val.length == 1 && !isNaN(val)) {
      this.setState({
        resultant_ph_no: this.props.globalData.formData.dial_code + ' ' + val
      });
    }
    if (val.length < dial_code_length) return;
    let mobile_number = val.substring(dial_code_length + 1).trim();
    if (validateUserPhoneNumber(mobile_number,this.props.globalData.locale)) {
      this.setState({ ph_no_border_validated: true });
      logEvent(this.state.eventCategory, EVENT_ACTIONS.MOBILE_NUMBER_ENTERED, mobile_number);
    }
    // this.setState({ ph_no_border: normal_border });

    if (isNaN(mobile_number)) return;
    this.props.globalActions.dataUpdate('mobile_number', mobile_number);
    this.setState({
      resultant_ph_no:
        this.props.globalData.formData.dial_code + ' ' + mobile_number
    });
  };

  flag = country_iso_code => {
    let dialCode = allCountriesData[country_iso_code][0];
    let flagPos = (allCountriesData[country_iso_code][1] - 1) * 16;
    this.props.globalActions.dataUpdate('dial_code', dialCode);
    this.props.globalActions.dataUpdate('flagPos', flagPos);
    this.setState(
      { resultant_ph_no: dialCode + ' ', flagPos: flagPos },
      this.changeMobile()
    );
  };
  flagAndDialCode(country_iso_code, mobile_number) {
    let dialCode = allCountriesData[country_iso_code][0];
    let flagPos = (allCountriesData[country_iso_code][1] - 1) * 16;
    this.props.globalActions.dataUpdate('dial_code', dialCode);
    this.props.globalActions.dataUpdate('flagPos', flagPos);
    this.setState({ resultant_ph_no: dialCode + ' ' + mobile_number });
    this.setState({ flagPos: flagPos });
  }

  changeMobile = () => {
    let showDropdownMobile = this.state.showDropdownMobile;
    this.setState({ showDropdownMobile: !showDropdownMobile });
  };

  // generic functions. TODO: Try and remove the repetition in every module

  getContent = key => {
    if (
      this.props &&
      this.props.globalData &&
      this.props.globalData.landing_translations &&
      this.props.viewMode
    ) {
      return this.props.globalData.landing_translations[key];
    }
    return null;
  };

  getUniversalContent = key => {
    if (
      this.props &&
      this.props.globalData &&
      this.props.globalData.universal_translations &&
      this.props.viewMode
    ) {
      if (key in this.props.globalData.universal_translations)
        return this.props.globalData.universal_translations[key];
    }
    return null;
  };

  getStyle = style_id => {
    if (style_id in Styles) return Styles[style_id][this.props.viewMode];
    console.log(style_id + ' style not initialized.');
    return {};
  };

  getImage = image_id => {
    if (image_id in LandingImages) {
      return (
        S3HOST +
        '/' +
        this.props.globalData.universal_translations[
          LandingImages[image_id][this.props.viewMode]
        ]
      );
    }
    console.log(image_id + ' image not initialized.');
    return null;
  };

  validateOneField = field => {
    switch (field) {
      case validation.HOME_ADDRESS:
        if (this.props.globalData.formData.hotel_address.length == 0) {
          this.setState({ hotel_address_border_validated: false });
          return false;
        }
        this.setState({ hotel_address_border_validated: true });
        return true;

      case validation.HOME_STRUCTURE_TYPE:
        if (this.props.globalData.formData.structure_type_home.length == 0) {
          this.setState({ struct_type_validated: false });
          return false;
        }
        this.setState({ struct_type_validated: true });
        return true;

      case validation.HOTEL_EMAIL:
        let email = this.props.globalData.formData.email_address;
        let aInd = email.indexOf('@');
        let dotInd = email.lastIndexOf('.');
        if (email.length == 0 || aInd < 0 || dotInd < aInd) {
          this.setState({ email_border_validated: false });
          if (this.state.oyoFormMode == oyoFormView.signUpScreen) {
            this.props.globalActions.errorSignUp({
              message: 'Please enter a valid email.'
            });
          }
          return false;
        }
        this.setState({ email_border_validated: true });
        return true;

      case validation.LOCATION:
        if (!this.state.selectedLocation) {
          this.setState({ location_border_validated: false });
          return false;
        } else {
          this.setState({ location_border_validated: true });
          return true;
        }
      case validation.LOCATION_OBJECT:
        if (Object.keys(this.props.globalData.selected_location).length == 0) {
          this.setState({ location_border_validated: false });
          return false;
        } else {
          this.setState({ location_border_validated: true });
          return true;
        }

      case validation.REVENUE_POTENTIAL:
        if (
          !this.props.globalData.earning_potential_data.noDataForCity &&
          this.props.globalData.earning_potential_data.data.length == 0
        ) {
          this.setState({ location_border_validated: false });
          return false;
        } else {
          return true;
        }

      case validation.PHONE_NUMBER:
        if (
          !validateUserPhoneNumber(this.props.globalData.formData.mobile_number,this.props.globalData.locale)
        ) {
          this.setState({ ph_no_border_validated: false });
          return false;
        } else {
          this.setState({ ph_no_border_validated: true });
          return true;
        }

      case validation.FULL_NAME:
        if (!this.props.globalData.formData.full_name) {
          this.setState({ name_border_validated: false });
          return false;
        } else {
          this.setState({ name_border_validated: true });
          return true;
        }

      case validation.HOTEL_PROPERTY_NAME:
        if (this.props.globalData.formData.hotel_name.length == 0) {
          this.setState({ hotel_name_border_validated: false });
          return false;
        }
        this.setState({ hotel_name_border_validated: true });
        return true;

      default:
        return false;
    }
  };
  
  handleClickAway = () =>{
    let location_error = '';
    if(!this.state.selectedLocation && this.state.location)
      location_error = this.guc('location_error') ;
    
    this.setState({ showDropdown  : false , location_error : location_error });
  };
  
  validateGenOtpFields = () => {
    let nameValidated = this.validateOneField(
        validation.FULL_NAME
    );
    let phoneValidated = this.validateOneField(
        validation.PHONE_NUMBER
    );
    let locationValidated = this.validateOneField(
        validation.LOCATION
    );
    
    return [nameValidated,phoneValidated,locationValidated]
  };
  
  

  render() {
    let gc = this.getContent;
    let guc = this.guc;
    let gi = this.gi;
    let gs = this.gs;
    let vm = this.props.viewMode;

    let formContainerStyle = {
      ...gs('formMain')
    };
    if (vm == view.DESKTOP) {
      formContainerStyle['right'] = this.props.rightMarginForForm + 'px';
      formContainerStyle['height'] =
        oyoFormHeights['height'][vm][this.state.oyoFormMode] +
        oyoFormHeights['bottom_extra'][vm][this.state.oyoFormMode];
    } else if (vm == view.MOBILE) {
      formContainerStyle['height'] =
        oyoFormHeights['height'][vm][this.state.oyoFormMode] +
        oyoFormHeights['bottom_extra'][vm][this.state.oyoFormMode];
    }

    if (this.props.highLightForm) {
      formContainerStyle = {
        ...formContainerStyle,
        border: 'solid 3px rgba(240, 0, 0, 0.7)'
      };
    }
    return (
      <React.Fragment>
        {vm && (
          <div className={'animate'} style={formContainerStyle}>
            <div
              style={{
                height: '100%',
                width: '100%',
                position: 'relative'
              }}
            >
              {!(
                this.props.globalData.otpData.isFetching ||
                this.props.globalData.signUpData.isFetching ||
                this.props.globalData.propertyData.isFetching ||
                this.props.globalData.loginData.isFetchingTwo
              ) && (
                <React.Fragment>
                  {this.state.oyoFormMode == oyoFormView.signUpScreen && (
                    <SignUpScreenWidget
                      guc={guc}
                      gi={gi}
                      gs={gs}
                      gc={gc}
                      viewMode={vm}
                      globalData={this.props.globalData}
                      globalActions={this.props.globalActions}
                      oyoFormMode={this.state.oyoFormMode}
                      email_border_validated={this.state.email_border_validated}
                      validateOneField={this.validateOneField}
                      setSignUpFunction={this.setSignUpFunction}
                      regenerateOtp={this.regenerateOtp}
                      changeFormScreen={this.changeFormScreen}
                      utm_data={this.props.utm_data}
                    />
                  )}

                  {this.state.oyoFormMode == oyoFormView.otpScreen && (
                    <GenerateOtpWidget
                      viewMode={vm}
                      globalData={this.props.globalData}
                      globalActions={this.props.globalActions}
                      validateOneField={this.validateOneField}
                      location_border_validated={
                        this.state.location_border_validated
                      }
                      location_border={this.state.location_border}
                      onLocationTextUpdate={this.onLocationTextUpdate}
                      changeLocationDropdown={this.changeLocationDropdown}
                      showDropdown={this.state.showDropdown}
                      dropDownOptions={this.state.dropDownOptions}
                      onClickDropdown={this.onClickDropdown}
                      name_border_validated={this.state.name_border_validated}
                      ph_no_border_validated={this.state.ph_no_border_validated}
                      resultant_ph_no={this.state.resultant_ph_no}
                      changeFormScreen={this.changeFormScreen}
                      flagPos={this.state.flagPos}
                      changeMobile={this.changeMobile}
                      showDropdownMobile={this.state.showDropdownMobile}
                      onChangeMobileInput={this.onChangeMobileInput}
                      flag={this.flag}
                      gc={gc}
                      guc={guc}
                      gi={gi}
                      gs={gs}
                      handleClickAway={this.handleClickAway}
                      location_error={this.state.location_error}
                    />
                  )}

                  {this.state.oyoFormMode == oyoFormView.hotelStepTwo && (
                    <HotelStepTwoWidget
                      gc={gc}
                      guc={guc}
                      gi={gi}
                      gs={gs}
                      globalData={this.props.globalData}
                      globalActions={this.props.globalActions}
                      oyoFormMode={this.state.oyoFormMode}
                      hotel_name_border_validated={
                        this.state.hotel_name_border_validated
                      }
                      email_border_validated={this.state.email_border_validated}
                      hotel_address_border_validated={
                        this.state.hotel_address_border_validated
                      }
                      validateOneField={this.validateOneField}
                      changeFormScreen={this.changeFormScreen}
                    />
                  )}

                  {this.state.oyoFormMode == oyoFormView.homeStepTwo && (
                    <HomeStepTwoWidget
                      gc={gc}
                      gi={gi}
                      gs={gs}
                      guc={guc}
                      viewMode={vm}
                      globalData={this.props.globalData}
                      globalActions={this.props.globalActions}
                      oyoFormMode={this.state.oyoFormMode}
                      hotel_name_border_validated={
                        this.state.hotel_name_border_validated
                      }
                      email_border_validated={this.state.email_border_validated}
                      hotel_address_border_validated={
                        this.state.hotel_address_border_validated
                      }
                      struct_type_validated={this.state.struct_type_validated}
                      validateOneField={this.validateOneField}
                      changeFormScreen={this.changeFormScreen}
                    />
                  )}

                  {(this.state.oyoFormMode == oyoFormView.checkEarnings ||
                    this.state.oyoFormMode == oyoFormView.hotelBasic ||
                    this.state.oyoFormMode == oyoFormView.homeBasic ||
                    this.state.oyoFormMode == oyoFormView.lifeBasic ||
                    this.state.oyoFormMode == oyoFormView.hmsSelfOnboardingHome)
                     && (
                    <CheckEarningsWidget
                      gc={gc}
                      guc={guc}
                      gi={gi}
                      gs={gs}
                      viewMode={vm}
                      globalData={this.props.globalData}
                      globalActions={this.props.globalActions}
                      oyoFormMode={this.state.oyoFormMode}
                      validateOneField={this.validateOneField}
                      location_border={this.state.location_border}
                      onLocationTextUpdate={this.onLocationTextUpdate}
                      changeLocationDropdown={this.changeLocationDropdown}
                      resultant_ph_no={this.state.resultant_ph_no}
                      location_border_validated={
                        this.state.location_border_validated
                      }
                      showDropdown={this.state.showDropdown}
                      dropDownOptions={this.state.dropDownOptions}
                      onClickDropdown={this.onClickDropdown}
                      name_border_validated={this.state.name_border_validated}
                      ph_no_border_validated={this.state.ph_no_border_validated}
                      changeFormScreen={this.changeFormScreen}
                      flagPos={this.state.flagPos}
                      changeMobile={this.changeMobile}
                      showDropdownMobile={this.state.showDropdownMobile}
                      flag={this.flag}
                      onChangeMobileInput={this.onChangeMobileInput}
                      handleClickAway={this.handleClickAway}
                      location_error={this.state.location_error}
                      eventCategory={this.state.eventCategory}
                    />
                  )}

                  {this.state.oyoFormMode == oyoFormView.loginScreen && (
                    <LoginWidget
                      gc={gc}
                      guc={guc}
                      gi={gi}
                      gs={gs}
                      viewMode={vm}
                      globalData={this.props.globalData}
                      globalActions={this.props.globalActions}
                      oyoFormMode={this.state.oyoFormMode}
                      email_border_validated={this.state.email_border_validated}
                      setLoginFunction={this.setLoginFunction}
                      changeFormScreen={this.changeFormScreen}
                      successful_sign_up={this.state.successful_sign_up}
                      handleGreenButtonOnClick={this.handleGreenButtonOnClick}
                    />
                  )}
                  {this.state.oyoFormMode == oyoFormView.loginWithOtpStepOne && (
                      <LoginWithOtpStepOneWidget
                          gc={gc}
                          guc={guc}
                          gi={gi}
                          gs={gs}
                          viewMode={vm}
                          ph_no_border_validated={this.state.ph_no_border_validated}
                          resultant_ph_no={this.state.resultant_ph_no}
                          globalData={this.props.globalData}
                          globalActions={this.props.globalActions}
                          oyoFormMode={this.state.oyoFormMode}
                          flagPos={this.state.flagPos}
                          changeMobile={this.changeMobile}
                          showDropdownMobile={this.state.showDropdownMobile}
                          onChangeMobileInput={this.onChangeMobileInput}
                          flag={this.flag}
                          changeFormScreen={this.changeFormScreen}
                      />
                  )}
                  {this.state.oyoFormMode == oyoFormView.loginWithOtpStepTwo && (
                      <LoginWithOtpStepTwoWidget
                          gc={gc}
                          guc={guc}
                          gi={gi}
                          gs={gs}
                          viewMode={vm}
                          ph_no_border_validated={this.state.ph_no_border_validated}
                          resultant_ph_no={this.state.resultant_ph_no}
                          globalData={this.props.globalData}
                          globalActions={this.props.globalActions}
                          oyoFormMode={this.state.oyoFormMode}
                          flagPos={this.state.flagPos}
                          changeMobile={this.changeMobile}
                          showDropdownMobile={this.state.showDropdownMobile}
                          onChangeMobileInput={this.onChangeMobileInput}
                          flag={this.flag}
                          regenerateOtp={this.regenerateOtp}
                          setLoginFunction={this.setLoginFunction}
                          changeFormScreen={this.changeFormScreen}
                      />
                  )}

                  {this.state.oyoFormMode != oyoFormView.otpScreen && (
                    <div
                      className={'hoverColor'}
                      onClick={this.handleGreenButtonOnClick}
                      style={{
                        ...gs('big_green_button'),
                        position: 'absolute',
                        left: '0px',
                        right: '0px',
                        bottom:
                          22 +
                          oyoFormHeights['bottom_extra'][vm][
                            this.state.oyoFormMode
                          ] +
                          'px'
                      }}
                    >
                      <div
                        style={{
                          position: 'relative',
                          width: '100%',
                          height: '100%'
                        }}
                      >
                        <div style={{ ...centerAbs, width: '100%' }}>
      
                              {this.state.oyoFormMode ==
                            oyoFormView.checkEarnings && (hmsSelfOnboardingEnabled() ? guc('become_a_patron') : guc('get_associated'))}

                          {this.state.oyoFormMode == oyoFormView.homeBasic &&
                            guc('talk_to_repr_sub')}

                            {this.state.oyoFormMode == oyoFormView.lifeBasic &&
                            guc('get_associated_with_oyo_life')}

                          {this.state.oyoFormMode == oyoFormView.otpScreen &&
                            guc('generate_otp')}

                          {this.state.oyoFormMode == oyoFormView.signUpScreen &&
                            guc('create_account')}

                          {this.state.oyoFormMode == oyoFormView.loginScreen &&
                            guc('login')}

                          {this.state.oyoFormMode == oyoFormView.hotelBasic &&
                            guc('talk_to_repr_sub')}

                          {this.state.oyoFormMode == oyoFormView.homeStepTwo &&
                            guc('submit_and_finish')}

                          {this.state.oyoFormMode == oyoFormView.hotelStepTwo &&
                            guc('submit_and_finish')}

                          {this.state.oyoFormMode ==
                            oyoFormView.forgotPassword && guc('reset_pwd')}
  
                          {this.state.oyoFormMode == oyoFormView.loginWithOtpStepOne &&
                          guc('generate_otp')}
  
                          {this.state.oyoFormMode == oyoFormView.loginWithOtpStepTwo &&
                          guc('login')}
                          {this.state.oyoFormMode == oyoFormView.hmsSelfOnboardingHome &&
                          guc('become_a_patron')}
                        </div>
                      </div>
                    </div>
                  )}

                  {this.state.oyoFormMode == oyoFormView.otpScreen && (
                    <div
                      style={{
                        ...gs('bottom_container_form'),
                        bottom:
                          5 +
                          oyoFormHeights['bottom_extra'][vm][
                            this.state.oyoFormMode
                          ] +
                          'px'
                      }}
                    >
                      <div
                        style={{
                          position: 'relative',
                          width: '100%',
                          height: '100%',
                          display: 'flex'
                        }}
                      >
                        <div
                          onClick={this.handleGreenButtonOnClick}
                          className={'hoverColor'}
                          style={{
                            ...gs('big_green_button'),
                            width: '50%',
                            position: 'relative',
                            marginLeft:'-3px'
                          }}
                        >
                          <div style={{ ...centerAbs, width: '100%' }}>
                            {guc('sign_up_slash_gen_otp')}
                          </div>
                        </div>

                        <div
                          style={{
                            width: '10%',
                            position: 'relative',
                            textAlign: 'center'
                          }}
                        >
                          <div style={{ ...centerAbs, width: '100%' }}>
                            {guc('or')}
                          </div>
                        </div>

                        <div
                          onClick={e => {
                            let [nameValidated,phoneValidated,locationValidated] = this.validateGenOtpFields();
                            if (nameValidated && phoneValidated && locationValidated) {
                              const ctaData = {
                                name: path(this.props.globalData.formData,'full_name',''),
                                phone:  path(this.props.globalData.formData,'mobile_number',''),
                                city: path(this.state.selectedLocation, 'city.name',''),
                                state:path(this.state.selectedLocation,'state.name',''),
                                country:path(this.state.selectedLocation,'country.name',''),
                              };
                              logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOTEL, EVENT_ACTIONS.STEP_2_REQUEST_A_CALL_CLICKED, JSON.stringify(ctaData), '', EVENT_NAME.LEAD, EVENT_TYPE.TRACK);
                              this.changeFormScreen(oyoFormView.hotelStepTwo);
                              this.props.globalActions.putPropertyfetch(this.getBasicDataToStore());
                            }
                          }}
                          className={'hoverColor'}
                          style={{
                            ...gs('big_green_button'),
                            width: '40%',
                            position: 'relative'
                          }}
                        >
                          <div style={{ ...centerAbs, width: '100%' }}>
                            {guc('talk_to_repr_sub')}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div style={gs('bottom_nav')}>
                    {/* bottom navigations */}

                    <BottomNavigations
                      gc={gc}
                      gi={gi}
                      gs={gs}
                      guc={guc}
                      viewMode={vm}
                      globalData={this.props.globalData}
                      globalActions={this.props.globalActions}
                      oyoFormMode={this.state.oyoFormMode}
                      changeFormScreen={this.changeFormScreen}
                    />
                  </div>
                </React.Fragment>
              )}

                {(this.props.globalData.otpData.isFetching ||
                  this.props.globalData.signUpData.isFetching ||
                  this.props.globalData.propertyData.isFetching ||
                  this.props.globalData.loginData.isFetchingTwo) && (
                <div style={centerAbs}>
                  <CircularProgress />
                </div>
              )}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer,
    translationsData:state.translationsReducer,
    resizeData: state.resizeReducer
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BecomeAnOyoScreen);
